import React, { useState } from "react";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { getUserCompaniesForUser } from "../../../reducers/userCompanies";
import withModal from "../withModal";
import { hideModal } from "../../../actions/actionCreators";
import { requestUpdateUserTableauAccess } from "../../../actions/userActions";
import MaterialModal from "../MaterialModal";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableHeader from "../../material-components/Table/TableHeader";
import TableBody from "../../material-components/Table/TableBody";
import Checkbox from "@material-ui/core/Checkbox";
import { stableSort, getSorting } from "../../../helpers/materialTableFunctions";

const UserTableauAccessModal = ({ isOpen, modalProps }) => {
    const dispatch = useDispatch();

    const [order, setOrder] = useState("asc");
    const [orderBy, setOrderBy] = useState("CompanyName");

    const user = useSelector(state => state.users.byId[modalProps.userId || 0]);
    const companies = useSelector(state => state.companies.byId);
    const userCompanies = useSelector(state => getUserCompaniesForUser(state, modalProps) || []);

    const hide = () => {
        setOrder("asc");
        setOrderBy("CompanyName");
        dispatch(hideModal("USER_TABLEAU_ACCESS"));
    };

    const renderNewUiTable = () => {
        // Create Table with Company Name
        const displayCompanies = userCompanies.map(x => {
            x = { ...x, CompanyName: getCompanyName(x.CompanyID) };
            return x;
        });

        let tableData = [];
        let tableHeaders = [
            ["CompanyName", "Company", "smDown"],
            ["TableauAccess1", "Interact Access?", "smDown", "center"],
            ["TableauAccess2", "Edit Access?", "smDown", "center"],
        ];

        const emptyMessage = ["EmptyMessage", "No companies available.", "smDown"];
        const ignoreHeaders = ["TableauAccess1", "TableauAccess2"];
        stableSort(displayCompanies, getSorting(order, orderBy)).map(dataRow => {
            tableData.push([
                ["CompanyName", dataRow.CompanyName, "smDown"],
                ["TableauAccess1", renderTableauInteractAccess(dataRow), "smDown", "center"],
                ["TableauAccess2", renderTableauEditAccess(dataRow), "smDown", "center"],
            ]);
        });

        return (
            <Paper style={{ maxHeight: 450, overflow: "auto" }}>
                <Table stickyHeader style={{ marginTop: 0 }}>
                    <TableHeader
                        headers={tableHeaders}
                        widget={false}
                        ignoreHeaders={ignoreHeaders}
                        orderBy={orderBy}
                        order={order}
                        onClick={handleRequestSort}
                    />
                    <TableBody
                        data={tableData}
                        emptyMessage={emptyMessage}
                        widget={false}
                        page={0}
                        rowsPerPage={userCompanies.length}
                    />
                </Table>
            </Paper>
        );
    };

    const handleRequestSort = (event, property) => {
        order === "asc" ? setOrder("desc") : setOrder("asc");
        setOrderBy(property);
    };

    const getCompanyName = companyId => {
        const company = companies[companyId];
        if (!company) {
            return companyId;
        }
        return company.CompanyName;
    };

    const renderTableauInteractAccess = row => {
        const userCompany = row;
        const value = userCompany.TableauAccess == "I" || userCompany.TableauAccess == "E";
        return (
            <Checkbox
                checked={value}
                value={value}
                onClick={() =>
                    handleTableauAccessChange(
                        userCompany.ID,
                        userCompany.CompanyID,
                        "I",
                        userCompany.TableauAccess,
                        !value
                    )
                }
                icon={
                    <i className="material-icons" style={{ fontSize: 16 }}>
                        check_box_outline_blank
                    </i>
                }
                checkedIcon={
                    <i className="material-icons" style={{ fontSize: 16 }}>
                        check_box
                    </i>
                }
                style={{ color: "#406eb3", height: 16, width: 16, margin: "0px 10px" }}
                color="primary"
            />
        );
    };

    const renderTableauEditAccess = row => {
        const userCompany = row;
        const value = userCompany.TableauAccess == "E";
        return (
            <Checkbox
                checked={value}
                value={value}
                onClick={() =>
                    handleTableauAccessChange(
                        userCompany.ID,
                        userCompany.CompanyID,
                        "E",
                        userCompany.TableauAccess,
                        !value
                    )
                }
                icon={
                    <i className="material-icons" style={{ fontSize: 16 }}>
                        check_box_outline_blank
                    </i>
                }
                checkedIcon={
                    <i className="material-icons" style={{ fontSize: 16 }}>
                        check_box
                    </i>
                }
                style={{ color: "#406eb3", height: 16, width: 16, margin: "0px 10px" }}
                color="primary"
            />
        );
    };

    const handleTableauAccessChange = (userCompanyId, companyId, accessType, oldValue, checked) => {
        let newVal = null;
        if (accessType == "I" && checked) {
            newVal = accessType;
        } else if (accessType == "E") {
            newVal = checked ? "E" : "I";
        }
        dispatch(requestUpdateUserTableauAccess(user.Id, userCompanyId, companyId, oldValue, newVal));
    };

    return user ? (
        <MaterialModal
            id="user-tableau-modal"
            isOpen={isOpen}
            onClose={hide}
            title={"Tableau Edit"}
            showPrimaryButton={false}
            cancelButtonText="Close"
        >
            <div>
                <strong>ID:</strong> {user.Id}
            </div>
            <div>
                <strong>User Name:</strong> {user.UserName}
            </div>
            <Paper style={{ margin: "20px auto" }}>{renderNewUiTable()}</Paper>
        </MaterialModal>
    ) : null;
};

UserTableauAccessModal.propTypes = {
    modalProps: PropTypes.object,
    isOpen: PropTypes.bool,
    // Injected from Redux (ActionCreators)
    hideModal: PropTypes.func,
    user: PropTypes.object,
    companies: PropTypes.object,
    userCompanies: PropTypes.array,
    requestUpdateUserTableauAccess: PropTypes.func,
};

export default withModal(UserTableauAccessModal, "USER_TABLEAU_ACCESS");
